// extracted by mini-css-extract-plugin
module.exports = {"item":"Menu_item__5MKHp","control":"Menu_control__Nn6RJ","panel":"Menu_panel__Mj_fG","label":"Menu_label__wjjez","chevron":"Menu_chevron__WDv__"};